import { render } from "./Verifications.vue?vue&type=template&id=5b166ef7"
import script from "./Verifications.vue?vue&type=script&lang=js"
export * from "./Verifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__